import NoData from "assets/svgs/no_data/NoData";
import { getFormattedDate } from "modules/utilities/utility";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useRecentOrdersStore } from "./store";
import Loader from "modules/Loader";
import moment from "moment";
import SoftBadge from "modules/common/SoftBadge";

function GhostOrderTable({ ghostTableData, isLoading, assign, countAssign }) {
  const [filterGhostData, setFilterGhostData] = useState([]);
  useEffect(() => {
    setFilterGhostData(ghostTableData);
  }, [ghostTableData]);
  const [allFlag, setAllFlag] = useState(false);
  const { setToaster } = useToast();
  const { assignRecentOrders } = useRecentOrdersStore();

  const header = ["Order Id", "Order Name", "Order Date", "Assigned To"];

  useEffect(() => {
    if (countAssign == 0) {
      return;
    } else {
      const checkedData = filterGhostData?.filter((ghost) => {
        return ghost.checked;
      });

      const data = checkedData?.map((ghost) => {
        return {
          case_id: ghost?.case_id,
          user_id: assign,
          order_id: ghost?.key,
        };
      });
      assignRecentOrders(data, setToaster);
    }
  }, [countAssign]);

  const handleChange = (event, itemId) => {
    if (event.target.checked) {
      setFilterGhostData((prevData) =>
        prevData?.map((ghost) =>
          ghost?.key === itemId ? { ...ghost, checked: true } : ghost
        )
      );
    } else {
      setFilterGhostData((prevData) =>
        prevData?.map((ghost) =>
          ghost.key === itemId ? { ...ghost, checked: false } : ghost
        )
      );
    }
  };

  const handleAllChange = (event) => {
    if (event.target.checked) {
      setFilterGhostData((prevData) =>
        prevData?.map((ghost) => ({ ...ghost, checked: true }))
      );
      setAllFlag(true);
    } else {
      setFilterGhostData((prevData) =>
        prevData?.map((ghost) => ({ ...ghost, checked: false }))
      );
      setAllFlag(false);
    }
  };

  return (
    <div>
      <table
        className="d-flex flex-column mt-1  rounded table-hover scrollable-container"
        style={{
          minHeight: "10vh",
          maxHeight: "65vh",
          overflowY: "scroll",
        }}
      >
        <thead className="d-flex text-gray border-black border rounded-top table-head position-sticky top-0">
          <th
            className="flex-1 fw-bold text-secondary  ps-2 border-end py-2 mt-1"
            style={{ zIndex: "9999" }}
          >
            <div className="form-check" style={{ marginLeft: "0.3rem" }}>
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    <div className="fw-bold">Select All</div>
                  </Tooltip>
                }
              >
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckIndeterminate"
                  onChange={handleAllChange}
                  checked={allFlag ? true : false}
                  style={{ content: "-" }}
                />
              </OverlayTrigger>
              <label
                className="form-check-label fw-bold text-black"
                htmlFor="flexCheckIndeterminate"
              >
                Name
              </label>
            </div>
          </th>
          {header?.map((ghost) => (
            <th className="flex-1 fw-bold text- ps-2 border-end text-black mt-1 py-1">
              {ghost}
            </th>
          ))}
        </thead>
        <div>
          {isLoading ? (
            <div className="position-absolute mt-5 start-50 top-50 translate-middle">
              <Loader />{" "}
            </div>
          ) : filterGhostData ? (
            filterGhostData?.map((ghost, index) => {
              return (
                <tr
                  key={ghost?.key}
                  className={
                    ghost?.checked
                      ? `flex-1  border border-top-0  selected-table-row  ${
                          index === filterGhostData?.length - 1 &&
                          `rounded-bottom`
                        } d-flex justify-content-between `
                      : `flex-1 border border-top-0  table-row ${
                          index === filterGhostData?.length - 1 &&
                          `rounded-bottom`
                        } d-flex justify-content-between`
                  }
                >
                  <td className="flex-1 py-2 ms-1 pe-1 text-left  border-end text-break text-primary cursor-pointer fw-bold">
                    <div className="form-check ps-4">
                      <input
                        className="form-check-input ps-2"
                        type="checkbox"
                        value={ghost?.key}
                        id={`flexCheckIndeterminate-${ghost?.key}`}
                        onClick={(event) => handleChange(event, ghost?.key)}
                        checked={ghost?.checked}
                      />

                      <div
                        className="form-check-label fw-bold"
                        htmlFor={`flexCheckIndeterminate-${ghost?.key}`}
                      >
                        <OverlayTrigger
                          overlay={
                            <Tooltip
                              style={{ position: "fixed" }}
                              id="overlay-trigger-example"
                            >
                              <div className="fs-1">Lead Details</div>
                            </Tooltip>
                          }
                        >
                          <Link
                            to={`/lead-details/${ghost?.key}`}
                            className="text-primary"
                          >
                            <div className="text-break text-wrap">
                              {ghost?.name}
                            </div>
                            <div>{ghost?.phone_Number}</div>
                          </Link>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </td>
                  <td className="flex-1 py-2  pe-2 text-left   border-end text-break text-black">
                    <div>{ghost?.order_display_id}</div>
                    <SoftBadge bg="primary" className="me-2">
                      {ghost?.order_type?.replaceAll("_", " ")}
                    </SoftBadge>
                  </td>
                  <td className="flex-1 py-2  ps-2  text-left  border-end text-break text-black text-truncate">
                    <OverlayTrigger
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="overlay-trigger-example"
                        >
                          <div className="fw-bold">{ghost?.order_name}</div>
                        </Tooltip>
                      }
                    >
                      <div>{ghost?.order_name}</div>
                    </OverlayTrigger>
                  </td>
                  <td className="flex-1 py-2 ps-1 text-left border-end text-break text-black">
                    <div className="ps-2">
                      {moment(ghost?.order_date).format("DD MMM YYYY, h:mm a")}
                    </div>
                  </td>
                  <td className="flex-1 py-2 ps-2 text-left border-end pt-2 text-break text-primary ">
                    {ghost?.assigned_to}
                  </td>
                </tr>
              );
            })
          ) : (
            <h3 className="text-center border p-3 rounded-bottom bg-white text-black">
              Data not found <NoData />
            </h3>
          )}
        </div>
      </table>
    </div>
  );
}

export default GhostOrderTable;
